// ─── Identité d'un compte sur deux lignes (nom gras + adresse) ────
// Les listes d'accès ne stockent que des e-mails : le nom est résolu depuis
// les comptes. Une adresse autorisée mais pas encore inscrite n'a pas de nom —
// on montre alors l'adresse en principal et on le dit.
//
// ⚠️ `inscrit` est un paramètre À PART ENTIÈRE, et non `!!nom` : un compte bien
// réel peut n'avoir aucun prénom (comptes hérités, création par l'API). Déduire
// « pas inscrit » de « pas de nom », c'est accuser d'absence un compte qui vit —
// exactement le contresens constaté le 09/08 sur l'écran Accès. L'appelant SAIT
// si le document `users` existe ; il le dit, on ne le devine pas.
import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useUI, useT } from '@mop/core';

export default function LigneCompte({ email, nom, inscrit = false, sansAvatar = false }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const principal = nom || email || '?';
  // Trois états distincts, jamais confondus : nom connu · compte sans nom ·
  // aucun compte. Seul le dernier est une absence.
  const secondaire = nom ? email : t(inscrit ? 'admin.sansNom' : 'admin.nonInscrit');

  return (
    <View style={s.ligne}>
      {!sansAvatar && (
        <View style={s.avatar}><Text style={s.avatarTxt}>{String(principal)[0].toUpperCase()}</Text></View>
      )}
      <View style={{ flex: 1 }}>
        <Text style={s.nom} numberOfLines={1}>{principal}</Text>
        <Text style={[s.mail, !nom && s.absent]} numberOfLines={1}>{secondaire}</Text>
      </View>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ligne: { flexDirection: 'row', alignItems: 'center', gap: 10, flex: 1 },
  avatar: { width: 32, height: 32, borderRadius: 16, backgroundColor: UI.accentTint,
            alignItems: 'center', justifyContent: 'center' },
  avatarTxt: { fontSize: 13, fontWeight: '800', color: UI.accent },
  nom: { fontSize: 14, fontWeight: '800', color: UI.ink },
  mail: { fontSize: 12, color: UI.muted, marginTop: 1 },
  absent: { fontStyle: 'italic', color: UI.faint },
});
